import store from 'store'

store.watch(
  (state, getters) => getters.languageChartNeed,
  lang => {
    window.LANGUAGE = lang
  },
  {
    immediate: true
  }
)

store.watch(
  (state, getters) => getters.theme,
  theme => {
    const bodyClass = document.body.classList
    bodyClass.forEach(v => {
      if (v.indexOf('theme') > -1) {
        bodyClass.remove(v)
      }
    })
    document.body.classList.add(theme)
  },
  {
    immediate: true
  }
)
